var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicVerifyMaterial2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 174,
    viewBox: "0 0 204 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 88456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2708",
    d: "M75.6814 103.283C75.6814 88.7996 64.2117 75.7179 52.0461 68.7662C50.2149 67.7198 45.1785 65.1206 45.1785 62.7459C45.1785 59.7079 46.8499 56.7133 49.638 55.1201C56.132 51.4092 63.9306 52.5081 70.4192 54.362C72.3964 54.9269 75.992 57.6294 77.4652 58.9553C79.7046 60.9707 83.9838 61.5363 85.4923 63.9499C89.489 70.3446 99.1801 70.7497 105.56 72.9581C110.129 74.5397 118.334 79.2739 119.028 84.8204C119.413 87.9018 122.239 91.2445 122.239 94.4529C122.239 98.5659 121.436 102.579 121.436 106.494",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2709",
    d: "M88.5247 58.3316C88.5247 54.6265 90.1301 50.952 90.1301 47.495C90.1301 45.5667 90.7818 43.2191 91.5571 41.4747C92.6411 39.0357 91.2313 35.9868 92.3598 33.4476C92.9871 32.0362 93.3409 28.9765 93.3409 27.4273C93.3409 25.6451 94.9463 23.7794 94.9463 21.8083C94.9463 17.7234 97.301 13.5002 98.9599 9.7677C100.71 5.83012 102.459 2.14196 106.987 2.14196C109.84 2.14196 114.658 6.51721 115.014 9.36635C115.21 10.9351 116.196 12.8795 116.575 14.584C117.286 17.7846 116.619 21.7244 116.619 25.0192C116.619 29.157 115.014 32.7856 115.014 37.0598C115.014 39.0666 112.681 47.0674 112.681 49.0742C112.681 51.8575 115.157 40.9521 115.638 39.8693C116.833 37.1816 119.028 31.9733 119.028 29.0327C119.028 25.0861 121.794 21.175 122.238 17.3934C122.509 15.0917 124.347 9.30966 126.074 7.58255C128.769 4.88724 129.861 1.11568 134.68 2.18656C136.793 2.656 137.19 4.37591 138.293 5.75416C139.39 7.12534 138.309 10.0219 139.497 10.9718C141.628 12.6768 139.21 20.2637 139.095 22.2097C138.872 26.0094 136.899 29.8468 136.687 33.4476C136.47 37.1355 135.082 40.9057 135.082 44.2842C135.082 46.4541 133.181 51.93 133.181 54.0742C133.181 57.8439 136.124 47.8635 136.509 47.0937C140.305 39.5022 139.461 30.7022 143.51 23.4138C144.841 21.0179 146.019 13.5864 149.531 13.3799C152.064 13.2309 158.928 12.5923 159.163 16.5907C159.626 24.4579 159.163 32.1045 159.163 40.2707C159.163 47.7188 156.651 54.1832 155.105 61.1411C154.337 64.5975 153.965 68.8223 152.563 71.9777C150.852 75.8277 152.274 82.5953 149.709 85.8021C149.295 86.3191 148.728 90.536 148.728 91.2427C148.728 93.5754 147.122 95.7696 147.122 98.0657C147.122 101.476 144.049 104.607 143.153 107.743C141.974 111.872 134.339 123.351 129.463 123.351",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2710",
    d: "M74.0761 105.691C64.989 105.691 64.4598 121.483 72.4707 124.154",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2711",
    d: "M130.266 125.76C130.302 126.048 132.815 129.347 133.298 129.952C134.143 131.008 133.547 134.702 132.852 135.571C129.84 139.336 127.417 138.603 122.239 138.603",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2712",
    d: "M85.314 128.971C87.5673 128.971 88.8231 130.666 90.3086 132.003C91.4903 133.067 93.7032 132.311 94.7681 133.163C97.0822 135.014 101.133 134.071 103.776 135.392",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2713",
    d: "M120.633 140.209C120.423 141.894 117.404 143.662 116.62 145.427C115.722 147.447 112.941 150.399 111.447 151.893C109.154 154.186 107.664 160.618 106.184 163.577C104.784 166.377 103.931 168.644 102.974 171.515",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2714",
    d: "M70.0625 126.562C69.7001 129.824 66.7662 133.457 65.6476 136.641C64.3245 140.407 62.7357 143.937 61.2327 147.611C59.6987 151.361 58.0538 155.418 55.6138 158.671",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2715",
    d: "M173.612 50.3047C177.337 54.4959 176.385 65.9089 176.644 70.9076C177.207 81.7534 172.878 90.2332 169.598 100.073",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2716",
    d: "M191.271 38.2637C198.336 50.7441 202.153 63.7483 202.153 78.1316C202.153 85.3818 202.387 95.9953 198.496 102.48",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2717",
    d: "M45.1784 29.4336C40.5482 33.2921 36.9933 35.2898 33.3608 40.4931C27.9107 48.3 23.5374 55.8346 20.2944 64.7528",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2718",
    d: "M31.0319 19.3926C27.1916 22.8061 21.6751 24.3575 17.8807 28.5736C15.4355 31.2904 10.2665 35.8897 9.81627 39.4915C9.60006 41.2213 7.9186 42.7272 7.52102 44.5163C6.62253 48.5595 5.6821 53.539 3.98509 57.3573C1.98215 61.8639 2.00001 68.027 2.00001 72.9898",
    stroke: "#12C0B5",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2722",
    d: "M104.294 61.1913C117.194 61.1913 128.566 59.9179 136.345 71.5861",
    stroke: "#33333A",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicVerifyMaterial2);
export default __webpack_public_path__ + "static/media/graphic-verify-material-2.fbad63991aac17afd652efa548e46459.svg";
export { ForwardRef as ReactComponent };